import React, { Component } from 'react';
import moment from 'moment';
import { SERVER_URL } from './ServerConfig'
import InverterEnergyDetails from './inverter/InverterEnergyDetails'
import queryString from 'query-string';

export default class Inverter extends Component {

    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: true,
            inverter: null,
            params : params
        }

        this.mounted = true;

        this.handleBackBtnClick = this.handleBackBtnClick.bind(this);
    }

    componentDidMount() {
        this.fetchInverter();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    fetchInverter() {
        const id = this.state.params.id;
        let token = this.props.user.payload.token;
        fetch(SERVER_URL + '/v1/inverters/' + id + '/get', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (!this.mounted) {
                    return;
                }
                this.interval = setInterval(() => this.doFetchInterval(), 2000);
                this.setState({ isLoading: false, inverter: data.content });
            })
    }

    doFetchInterval() {
        clearInterval(this.interval);
        this.fetchInverter();
    }

    getStatus(item, mStatus) {
        if (!mStatus || !item.mTime) {
            return false;
        }
        const now = moment();
        const statusTime = moment(item.mTime).add(4, 'hours');

        const duration = now.diff(statusTime, 'minutes');
        if (duration > 15) {
            return false;
        }
        return true;
    }

    drawStatus(status) {
        if (status) {
            return (
                <span className="badge bg-success">ON</span>
            );
        }
        return (<span className="badge bg-danger">OFF</span>);
    }

    formatNumberWithStatus(number, status) {
        if (!status) {
            return 0;
        }
        return this.formatNumber(number);
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        return Number(number).toFixed(1);
    }

    handleBackBtnClick(event) {
        this.props.history.goBack();
    }


    render() {
        const inverter = this.state.inverter;
        const user = this.props.user;
        if (!inverter) {
            return (
                <h1>Loading...</h1>
            )
        }
        let status = false;
        let inverter_current = {};
        if (inverter.current.length > 0) {
            inverter_current = inverter.current[0];
            status = this.getStatus(inverter_current, inverter_current.mStatus);
        }

        return (            
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6 d-flex">
                                <button type="button" className="btn btn-default none-border mr-2" onClick={this.handleBackBtnClick} data-toggle="tooltip" data-placement="right" title="Back to previous page">
                                    <i className="fa fa-arrow-left fa-2"></i>
                                </button>
                                <h4>Inverter {inverter.mName}</h4>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="">
                    <div className="row">                        
                        <div className="col-12">
                            <InverterEnergyDetails history={this.props.history} user={user} inverter={inverter} />
                        </div>
                        <div className="card col-12 mt-4">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>IP</b> <div className="ml-4 float-right">{inverter.mIP}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Status</b> <div className="ml-4 float-right">{this.drawStatus(status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Energy </b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mEnergy / 1000, status)} MWh</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Temp</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mTemp, status)} °C</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>AC power</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mACpower / 1000, status)} kW</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>DC power</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mDCpower / 1000, status)} kW</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>AC Cur</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mACCur, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>DC Cur</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mDCcur, status)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>ACur</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mAcur, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>BCur</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mBcur, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>CCur</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mCcur, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>AVol</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mAvol, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>BVol</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mBvol, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>CVol</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mCvol, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>DCvol</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mDCvol, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Freq</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mFreq, status)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>AC AppPower</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mACAppPower / 1000, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>AC ReaPower</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mACReaPower / 1000, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>AC PowerFactor</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mACPowerFactor, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>OperState</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mOperState, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>StateCode</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mStateCode, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Bitmask</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mBitmask, status)}</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>Reserved</b> <div className="ml-4 float-right">{this.formatNumberWithStatus(inverter_current.mReserved, status)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}